// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addImage label {
  font-weight: bold;
}
.addImage input:focus {
  box-shadow: none;
}
.addImage select:focus {
  box-shadow: none;
}
/* td,th{max-width: fit-content;} */
.card table{
    /* border: 1px solid black; */
    line-height: 2.5rem;
}
#imageContainer {
    /* display: none; */
    margin-top: 10px;
    max-width: 10rem;
  }
  #imageContainer img{
    max-width: 10rem;
  }`, "",{"version":3,"sources":["webpack://./src/Component/Dashboard/image/image.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA,mCAAmC;AACnC;IACI,6BAA6B;IAC7B,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB","sourcesContent":[".addImage label {\n  font-weight: bold;\n}\n.addImage input:focus {\n  box-shadow: none;\n}\n.addImage select:focus {\n  box-shadow: none;\n}\n/* td,th{max-width: fit-content;} */\n.card table{\n    /* border: 1px solid black; */\n    line-height: 2.5rem;\n}\n#imageContainer {\n    /* display: none; */\n    margin-top: 10px;\n    max-width: 10rem;\n  }\n  #imageContainer img{\n    max-width: 10rem;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
